module.exports = __webpack_public_path__ + "img/7.23c6081f.png";